$(document).ready(() => {
  $('[data-toggle="popover-hover"]').popover({
    html: true,
    trigger: 'hover',
    placement: 'auto',
    content: function () { return '<img src="' + $(this).data('img') + '" alt="" class="img-fluid" />'; }
  });
});
